import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class FeatureToggleGuard {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const toggle = route.data?.['featureToggle'] as string | undefined;
    if (!toggle) return true;
    if (route.queryParams[toggle] === 'true') return true;
    return this.router.createUrlTree(['/insights/devices']);
  }
}
